import { replace, startCase, toLower } from 'lodash';

export const formatLabel = (input: string) => startCase(toLower(replace(input, '_', ' ')));
